import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../store";
import { getStoredUser, getAuthToken } from "../utils/authentication";
import { loginSuccess } from "../store/reducers/authSlice";
import { ROUTES } from "./constants";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!isAuthenticated) {
      const user = getStoredUser();
      if (user) {
        // Restore authentication state from stored token
        dispatch(
          loginSuccess({
            data: {
              ...user,
              firstName: user.firstName,
              lastName: user.lastName,
              accessToken: getAuthToken() || "",
            },
          }),
        );
      }
    }
  }, [dispatch, isAuthenticated]);

  // Get stored user to double-check authentication
  const storedUser = getStoredUser();

  if (!isAuthenticated && !storedUser) {
    return (
      <Navigate to={ROUTES.AUTH.LOGIN} state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
